import React from 'react';
import { Typography } from '@fullstory/components';
import { intl } from '@fullstory/intl';

interface UserSummaryProps {
  created: Date;
  email?: string;
}
export const UserSummary = (props: UserSummaryProps) => {
  // User Summary is <created date> [. @<domain>]
  // Show year if not current year.
  const createdText =
    props.created.getFullYear() != new Date().getFullYear()
      ? intl.formatMessage(
          { defaultMessage: 'Since {date, date, ::MMMdyy}', id: 'bWR5y1' },
          { date: props.created },
        )
      : intl.formatMessage(
          { defaultMessage: 'Since {date, date, ::MMMd}', id: 'dZCDH+' },
          { date: props.created },
        );

  const emailParts = props.email ? props.email.split('@') : null;
  if (!emailParts || emailParts.length != 2) {
    return (
      <Typography variant="heading7" color="neutrals-n7" tag="div" ellipsize>
        {createdText}
      </Typography>
    );
  }
  return (
    <Typography
      data-component="UserSummary"
      variant="heading7"
      color="neutrals-n7"
      title={props.email}
      tag="div"
      ellipsize
      className="fs-exclude"
    >
      @{emailParts[1]} &middot; {createdText}
    </Typography>
  );
};
